/**
 * Finds the first descendant (or the current) component for which
 * the function returns a truthy value
 */
export default function searchComponent<C extends { children: C[] }>(
  component: C,
  fn: (descendant: C, depth: number) => boolean,
  depth = 0,
): C | undefined | null {
  if (!fn) {
    return undefined;
  }
  if (fn(component, depth)) {
    return component;
  }
  const { children } = component;
  if (children) {
    for (let i = 0; i < children.length; i += 1) {
      const found = searchComponent(children[i], fn, depth + 1);
      if (found) {
        return found;
      }
    }
  }
  return undefined;
}
